export default {
  name: "XcpGameData"
};